import { action, observable } from 'mobx';
import TranslationRepository from '../TranslationRepository';
import { API_NOTIFICATION_KEY_TRANSLATIONS_MAP } from '../../constants/NotificationMappedTranslations';
import NotificationsCollection from '../../domain/entities/Notification/NotificationsCollection';
import ObjectUtils from '../../utils/ObjectUtils';

export interface NotificationsTranslations {
  [key: string]: string;
}

export interface INotificationsRepositoryConfig {
  notificationsCollection: NotificationsCollection;
  translationRepository: TranslationRepository;
}

// This repository is responsible of holding the NotificationsCollection and
// the translations for that collection
class MessagesRepository {
  @observable notificationsCollection: NotificationsCollection;

  @observable notificationsTranslations: NotificationsTranslations = {};

  private translationRepository: TranslationRepository;

  constructor(config: INotificationsRepositoryConfig) {
    this.notificationsCollection = config.notificationsCollection;
    this.translationRepository = config.translationRepository;
  }

  // Gets all translations that have an error assigned to it in TRANSLATIONS_MAP
  @action
  public loadNotificationsTranslations = async (): Promise<void> => {
    if (ObjectUtils.isEmpty(this.notificationsTranslations)) {
      const translations = this.translationRepository?.
        listRequiredTranslationSchema(Object.values(API_NOTIFICATION_KEY_TRANSLATIONS_MAP));
      this.notificationsTranslations = translations as NotificationsTranslations;
    }
  };
}

export default MessagesRepository;
